<template>
	<div class="sa-main" data-v-9c14ebd6>
		<div
			class="nuxt-loading-indicator"
			style="
				position: fixed;
				top: 0;
				right: 0;
				left: 0;
				pointer-events: none;
				width: 0%;
				height: 5px;
				opacity: 0;
				background: repeating-linear-gradient(
					to right,
					#00dc82 0%,
					#34cdfe 50%,
					#0047e1 100%
				);
				background-size: Infinity% auto;
				transition: width 0.1s, height 0.4s, opacity 0.4s;
				z-index: 999999;
			"></div>
		<div class="page-buy" data-v-f0e540bb>
			<div class="el-row main-contact panel-block" style="" data-v-f0e540bb>
				<div
					class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3"
					style=""
					data-v-f0e540bb></div>
				<div
					class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18"
					style=""
					data-v-f0e540bb>
					<div
						class="el-table--fit el-table--scrollable-x el-table--scrollable-y el-table--enable-row-transition el-table el-table--layout-fixed mobile is-scrolling-left"
						style="width: 100%; height: 1000px"
						data-prefix="el"
						data-v-f0e540bb="">
						<div class="el-table__inner-wrapper" style="height: 1000px">
							<div class="hidden-columns">
								<div data-v-f0e540bb=""></div>
								<div data-v-f0e540bb=""></div>
								<div data-v-f0e540bb=""></div>
								<div data-v-f0e540bb=""></div>
								<div data-v-f0e540bb=""></div>
							</div>

							<div class="el-table__header-wrapper">
								<table
									class="el-table__header"
									style="width: 910px"
									border="0"
									cellpadding="0"
									cellspacing="0">
									<colgroup>
										<col name="el-table_1_column_1" width="150" />
										<col name="el-table_1_column_2" width="190" />
										<col name="el-table_1_column_3" width="190" />
										<col name="el-table_1_column_4" width="190" />
										<col name="el-table_1_column_5" width="190" />
									</colgroup>
									<thead class="">
										<tr class="" style="">
											<th
												class="el-table_1_column_1 el-table-fixed-column--left is-last-column is-leaf el-table__cell"
												colspan="1"
												rowspan="1"
												style="left: 0px">
												<div class="cell">
													<div data-v-f0e540bb="" class="buy-item">
														<img
															data-v-f0e540bb=""
															class="buy-bg"
															src="@/assets/image/gmsq/buy-bg.png" />
														<span data-v-f0e540bb="">服务与功能</span>
													</div>
													<!----><!---->
												</div>
											</th>
											<th
												class="el-table_1_column_2 is-leaf el-table__cell"
												colspan="1"
												rowspan="1">
												<div class="cell">
													<div
														data-v-f0e540bb=""
														class="sa-flex-col sa-col-center">
														<div data-v-f0e540bb="" class="name">标准版</div>
														<div data-v-f0e540bb="" class="desc">
															适用于个人/企业自营
														</div>
														<div data-v-f0e540bb="" class="price">
															<span data-v-f0e540bb="">¥</span>1280<span
																data-v-f0e540bb=""
																>/套</span
															>
														</div>
														<div data-v-f0e540bb="" class="btn" @click="showpayfun(0)">立即购买</div>
													</div>
												</div>
											</th>
											<th
												class="el-table_1_column_3 is-leaf el-table__cell"
												colspan="1"
												rowspan="1">
												<div class="cell">
													<div
														data-v-f0e540bb=""
														class="sa-flex-col sa-col-center">
														<div data-v-f0e540bb="" class="name">专业版</div>
														<div data-v-f0e540bb="" class="desc">
															适用于企业商用
														</div>
														<div data-v-f0e540bb="" class="price">
															<span data-v-f0e540bb="">¥</span>6800<span
																data-v-f0e540bb=""
																>/套</span
															>
														</div>
														<div data-v-f0e540bb="" class="btn" @click="showpayfun(1)">立即购买</div>
													</div>
												</div>
											</th>
											<th
												class="el-table_1_column_4 is-leaf el-table__cell"
												colspan="1"
												rowspan="1">
												<div class="cell">
													<div
														data-v-f0e540bb=""
														class="sa-flex-col sa-col-center">
														<div data-v-f0e540bb="" class="name">企业版</div>
														<div data-v-f0e540bb="" class="desc">
															适用于科技公司/商业使用
														</div>
														<div data-v-f0e540bb="" class="price">
															<span data-v-f0e540bb="">¥</span>13800<span
																data-v-f0e540bb=""
																>/套</span
															>
														</div>
														<div data-v-f0e540bb="" class="btn" @click="showpayfun(2)">立即购买</div>
													</div>
												</div>
											</th>
											<th
												class="el-table_1_column_5 is-leaf el-table__cell"
												colspan="1"
												rowspan="1">
												<div class="cell">
													<div
														data-v-f0e540bb=""
														class="dingzi sa-flex-col sa-col-center">
														<div data-v-f0e540bb="" class="name">定制+</div>
														<div data-v-f0e540bb="" class="desc">
															私人化定制服务
														</div>
														<div data-v-f0e540bb="" class="price">按需定制</div>
														<div data-v-f0e540bb="" class="btn" @click="showcode = true">联系商务</div>
													</div>
													<!----><!---->
												</div>
											</th>
										</tr>
									</thead>
								</table>
							</div>
							<div class="el-table__body-wrapper">
								<div class="el-scrollbar">
									<div
										class="el-scrollbar__wrap el-scrollbar__wrap--hidden-default"
										style="height: 100%">
										<div
											class="el-scrollbar__view"
											style="display: inline-block; vertical-align: middle">
											<table
												class="el-table__body"
												cellspacing="0"
												cellpadding="0"
												border="0"
												style="table-layout: fixed; width: 910px">
												<colgroup>
													<col name="el-table_1_column_1" width="150" />
													<col name="el-table_1_column_2" width="190" />
													<col name="el-table_1_column_3" width="190" />
													<col name="el-table_1_column_4" width="190" />
													<col name="el-table_1_column_5" width="190" />
												</colgroup>
												<tbody>
													<tr style="" class="el-table__row bg-title">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	产品服务
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	安装文档
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	API接口文档
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	代码全部开源
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	永久支持与更新
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	工单解答
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	指导安装部署服务
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	1对1远程服务
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	售后1对1答疑
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	二次开发指导
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	全套设计资源
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-close1 error"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-title">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	站点设置
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	基本设置
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	上传配置
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	日志管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	广告管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	单页管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	管理员管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	上传管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	用户组管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
							<tr style="" class="el-table__row bg-title">
								<td
									class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
									rowspan="1"
									colspan="1"
									style="left: 0px">
									<div class="cell">
										<!---->
										<div data-v-f0e540bb="">
											陪玩管理
											<div data-v-f0e540bb="" class="horn"></div>
										</div>
									</div>
								</td>
								<td
									class="el-table_1_column_2 el-table__cell"
									rowspan="1"
									colspan="1">
									<div class="cell"><!----></div>
								</td>
								<td
									class="el-table_1_column_3 el-table__cell"
									rowspan="1"
									colspan="1">
									<div class="cell"><!----></div>
								</td>
								<td
									class="el-table_1_column_4 el-table__cell"
									rowspan="1"
									colspan="1">
									<div class="cell"><!----></div>
								</td>
								<td
									class="el-table_1_column_5 el-table__cell"
									rowspan="1"
									colspan="1">
									<div class="cell"><!----></div>
								</td>
							</tr>						
													
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	服务类型
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	标签管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													
																										<tr style="" class="el-table__row bg-1">
																											<td
																												class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																												rowspan="1"
																												colspan="1"
																												style="left: 0px">
																												<div class="cell">
																													<!---->
																													<div data-v-f0e540bb="">
																														游戏管理
																														<div data-v-f0e540bb="" class="horn"></div>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_2 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_3 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_4 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_5 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell"><!----></div>
																											</td>
																										</tr>
																																							<tr style="" class="el-table__row bg-1">
																																								<td
																																									class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																																									rowspan="1"
																																									colspan="1"
																																									style="left: 0px">
																																									<div class="cell">
																																										<!---->
																																										<div data-v-f0e540bb="">
																																											大神管理
																																											<div data-v-f0e540bb="" class="horn"></div>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_2 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_3 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_4 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_5 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell"><!----></div>
																																								</td>
																																							</tr>
																																							<tr style="" class="el-table__row bg-1">
																																								<td
																																									class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																																									rowspan="1"
																																									colspan="1"
																																									style="left: 0px">
																																									<div class="cell">
																																										<!---->
																																										<div data-v-f0e540bb="">
																																											大神申请
																																											<div data-v-f0e540bb="" class="horn"></div>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_2 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_3 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_4 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_5 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell"><!----></div>
																																								</td>
																																							</tr>
																																							<tr style="" class="el-table__row bg-1">
																																								<td
																																									class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																																									rowspan="1"
																																									colspan="1"
																																									style="left: 0px">
																																									<div class="cell">
																																										<!---->
																																										<div data-v-f0e540bb="">
																																											技能申请
																																											<div data-v-f0e540bb="" class="horn"></div>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_2 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_3 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_4 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_5 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell"><!----></div>
																																								</td>
																																							</tr>
																																							<tr style="" class="el-table__row bg-1">
																																								<td
																																									class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																																									rowspan="1"
																																									colspan="1"
																																									style="left: 0px">
																																									<div class="cell">
																																										<!---->
																																										<div data-v-f0e540bb="">
																																											技能管理
																																											<div data-v-f0e540bb="" class="horn"></div>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_2 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_3 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_4 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_5 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell"><!----></div>
																																								</td>
																																							</tr>
																																							<tr style="" class="el-table__row bg-1">
																																								<td
																																									class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																																									rowspan="1"
																																									colspan="1"
																																									style="left: 0px">
																																									<div class="cell">
																																										<!---->
																																										<div data-v-f0e540bb="">
																																											订单管理
																																											<div data-v-f0e540bb="" class="horn"></div>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_2 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_3 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_4 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_5 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell"><!----></div>
																																								</td>
																																							</tr>
																																							<tr style="" class="el-table__row bg-1">
																																								<td
																																									class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																																									rowspan="1"
																																									colspan="1"
																																									style="left: 0px">
																																									<div class="cell">
																																										<!---->
																																										<div data-v-f0e540bb="">
																																											订单评价
																																											<div data-v-f0e540bb="" class="horn"></div>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_2 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_3 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_4 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_5 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell"><!----></div>
																																								</td>
																																							</tr>
																																							<tr style="" class="el-table__row bg-1">
																																								<td
																																									class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																																									rowspan="1"
																																									colspan="1"
																																									style="left: 0px">
																																									<div class="cell">
																																										<!---->
																																										<div data-v-f0e540bb="">
																																											灵魂匹配
																																											<div data-v-f0e540bb="" class="horn"></div>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_2 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_3 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_4 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell">
																																										<!---->
																																										<div
																																											data-v-f0e540bb=""
																																											class="sa-flex sa-row-center">
																																											<i
																																												data-v-f0e540bb=""
																																												class="iconfont icon-check success"></i>
																																										</div>
																																									</div>
																																								</td>
																																								<td
																																									class="el-table_1_column_5 el-table__cell"
																																									rowspan="1"
																																									colspan="1">
																																									<div class="cell"><!----></div>
																																								</td>
																																							</tr>


													
													<tr style="" class="el-table__row bg-title">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	商城管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"></div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<div data-v-f0e540bb="">
																	商品管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	分类管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	订单管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	退款订单
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													
																								
													<tr style="" class="el-table__row bg-title">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	财务管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	充值管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	充值订单
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	提现管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	礼物记录
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													
													
													<tr style="" class="el-table__row bg-title">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	聊天派对
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	派对类别
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	官方消息
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	表情管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	派对管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	礼物管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	私信记录
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	音乐管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													
																									<tr style="" class="el-table__row bg-title">
																										<td
																											class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																											rowspan="1"
																											colspan="1"
																											style="left: 0px">
																											<div class="cell">
																												<!---->
																												<div data-v-f0e540bb="">
																													活动管理
																													<div data-v-f0e540bb="" class="horn"></div>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_2 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell"><!----></div>
																										</td>
																										<td
																											class="el-table_1_column_3 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell"><!----></div>
																										</td>
																										<td
																											class="el-table_1_column_4 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell"><!----></div>
																										</td>
																										<td
																											class="el-table_1_column_5 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell"><!----></div>
																										</td>
																									</tr>
																									<tr style="" class="el-table__row bg-1">
																										<td
																											class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																											rowspan="1"
																											colspan="1"
																											style="left: 0px">
																											<div class="cell">
																												<!---->
																												<div data-v-f0e540bb="">
																													活动列表
																													<div data-v-f0e540bb="" class="horn"></div>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_2 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell">
																												<!---->
																												<div
																													data-v-f0e540bb=""
																													class="sa-flex sa-row-center">
																													<i
																														data-v-f0e540bb=""
																														class="iconfont icon-check success"></i>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_3 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell">
																												<!---->
																												<div
																													data-v-f0e540bb=""
																													class="sa-flex sa-row-center">
																													<i
																														data-v-f0e540bb=""
																														class="iconfont icon-check success"></i>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_4 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell">
																												<!---->
																												<div
																													data-v-f0e540bb=""
																													class="sa-flex sa-row-center">
																													<i
																														data-v-f0e540bb=""
																														class="iconfont icon-check success"></i>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_5 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell"><!----></div>
																										</td>
																									</tr>
																									<tr style="" class="el-table__row bg-1">
																										<td
																											class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																											rowspan="1"
																											colspan="1"
																											style="left: 0px">
																											<div class="cell">
																												<!---->
																												<div data-v-f0e540bb="">
																													大转盘
																													<div data-v-f0e540bb="" class="horn"></div>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_2 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell">
																												<!---->
																												<div
																													data-v-f0e540bb=""
																													class="sa-flex sa-row-center">
																													<i
																														data-v-f0e540bb=""
																														class="iconfont icon-check success"></i>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_3 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell">
																												<!---->
																												<div
																													data-v-f0e540bb=""
																													class="sa-flex sa-row-center">
																													<i
																														data-v-f0e540bb=""
																														class="iconfont icon-check success"></i>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_4 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell">
																												<!---->
																												<div
																													data-v-f0e540bb=""
																													class="sa-flex sa-row-center">
																													<i
																														data-v-f0e540bb=""
																														class="iconfont icon-check success"></i>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_5 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell"><!----></div>
																										</td>
																									</tr>
																									<tr style="" class="el-table__row bg-1">
																										<td
																											class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																											rowspan="1"
																											colspan="1"
																											style="left: 0px">
																											<div class="cell">
																												<!---->
																												<div data-v-f0e540bb="">
																													宝箱管理
																													<div data-v-f0e540bb="" class="horn"></div>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_2 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell">
																												<!---->
																												<div
																													data-v-f0e540bb=""
																													class="sa-flex sa-row-center">
																													<i
																														data-v-f0e540bb=""
																														class="iconfont icon-check success"></i>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_3 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell">
																												<!---->
																												<div
																													data-v-f0e540bb=""
																													class="sa-flex sa-row-center">
																													<i
																														data-v-f0e540bb=""
																														class="iconfont icon-check success"></i>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_4 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell">
																												<!---->
																												<div
																													data-v-f0e540bb=""
																													class="sa-flex sa-row-center">
																													<i
																														data-v-f0e540bb=""
																														class="iconfont icon-check success"></i>
																												</div>
																											</div>
																										</td>
																										<td
																											class="el-table_1_column_5 el-table__cell"
																											rowspan="1"
																											colspan="1">
																											<div class="cell"><!----></div>
																										</td>
																									</tr>

													<tr style="" class="el-table__row bg-title">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	帖子管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													
																										<tr style="" class="el-table__row bg-1">
																											<td
																												class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																												rowspan="1"
																												colspan="1"
																												style="left: 0px">
																												<div class="cell">
																													<!---->
																													<div data-v-f0e540bb="">
																														帖子列表
																														<div data-v-f0e540bb="" class="horn"></div>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_2 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_3 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_4 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_5 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell"><!----></div>
																											</td>
																										</tr>
																										<tr style="" class="el-table__row bg-1">
																											<td
																												class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																												rowspan="1"
																												colspan="1"
																												style="left: 0px">
																												<div class="cell">
																													<!---->
																													<div data-v-f0e540bb="">
																														举报管理
																														<div data-v-f0e540bb="" class="horn"></div>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_2 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_3 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_4 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_5 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell"><!----></div>
																											</td>
																										</tr>
																										<tr style="" class="el-table__row bg-1">
																											<td
																												class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																												rowspan="1"
																												colspan="1"
																												style="left: 0px">
																												<div class="cell">
																													<!---->
																													<div data-v-f0e540bb="">
																														专题管理
																														<div data-v-f0e540bb="" class="horn"></div>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_2 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_3 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_4 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_5 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell"><!----></div>
																											</td>
																										</tr>
																										<tr style="" class="el-table__row bg-1">
																											<td
																												class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
																												rowspan="1"
																												colspan="1"
																												style="left: 0px">
																												<div class="cell">
																													<!---->
																													<div data-v-f0e540bb="">
																														机器人回复
																														<div data-v-f0e540bb="" class="horn"></div>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_2 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_3 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_4 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell">
																													<!---->
																													<div
																														data-v-f0e540bb=""
																														class="sa-flex sa-row-center">
																														<i
																															data-v-f0e540bb=""
																															class="iconfont icon-check success"></i>
																													</div>
																												</div>
																											</td>
																											<td
																												class="el-table_1_column_5 el-table__cell"
																												rowspan="1"
																												colspan="1">
																												<div class="cell"><!----></div>
																											</td>
																										</tr>


													<tr style="" class="el-table__row bg-title">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	会员管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													
																										<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	会员列表
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	头衔管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	大V申请
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	申请账号注销
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	批量生成
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>


													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	会员列表
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	头衔管理
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	大V申请
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	申请账号注销
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	批量生成
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>


													<tr style="" class="el-table__row bg-title">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	第三方对接
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	微信登录
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	微信支付（含服务商）
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	支付宝支付（含服务商）
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	快递鸟
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	ThinkApi
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	阿里云存储
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-1">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	腾讯云存储
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													<tr style="" class="el-table__row bg-2">
														<td
															class="el-table_1_column_1 el-table-fixed-column--left is-last-column el-table__cell"
															rowspan="1"
															colspan="1"
															style="left: 0px">
															<div class="cell">
																<!---->
																<div data-v-f0e540bb="">
																	七牛云存储
																	<div data-v-f0e540bb="" class="horn"></div>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_2 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_3 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_4 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell">
																<!---->
																<div
																	data-v-f0e540bb=""
																	class="sa-flex sa-row-center">
																	<i
																		data-v-f0e540bb=""
																		class="iconfont icon-check success"></i>
																</div>
															</div>
														</td>
														<td
															class="el-table_1_column_5 el-table__cell"
															rowspan="1"
															colspan="1">
															<div class="cell"><!----></div>
														</td>
													</tr>
													
													
													
													<!--]-->
												</tbody>
											</table>
											<!--v-if--><!--v-if--><!--]-->
										</div>
									</div>
									<!--[-->
									<div
										class="el-scrollbar__bar is-horizontal"
										style="display: none">
										<div
											class="el-scrollbar__thumb"
											style="transform: translateX(0%); width: 392.971px"></div>
									</div>
									<div
										class="el-scrollbar__bar is-vertical"
										style="display: none">
										<div
											class="el-scrollbar__thumb"
											style="
												transform: translateY(0%);
												height: 230.643px;
											"></div>
									</div>
								</div>
							</div>
						</div>
						<div
							class="el-table__column-resize-proxy"
							style="display: none"></div>
					</div>
					
					
					
					<div class="pc" data-v-f0e540bb>
						<div class="el-affix" style="min-height:230px" data-v-f0e540bb>
                     <!-- :style="affixname?'height: 230px;top: 60px; z-index: 100;':''" -->
							<div :class="affixname" >
								<div class="pc-header sa-flex" data-v-f0e540bb>
									<div class="pc-item-name" id="pc-item-name" data-v-f0e540bb>
										<div class="buy-item" data-v-f0e540bb>
											<img
												class="buy-bg"
												src="@/assets/image/gmsq/buy-bg.png"
												data-v-f0e540bb />
											<span data-v-f0e540bb>服务与功能</span>
										</div>
									</div>
									<div class="pc-item-icon" id="pc-item-icon" data-v-f0e540bb>
										<div class="sa-flex-col sa-col-center" data-v-f0e540bb>
											<div class="name" data-v-f0e540bb>标准版</div>
											<div class="desc" data-v-f0e540bb>
												适用于个人/企业自营
											</div>
											<div class="price" data-v-f0e540bb>
												<span data-v-f0e540bb>¥</span>
												1280<span data-v-f0e540bb>/套</span>
											</div>
											<div class="btn" data-v-f0e540bb @click="showpayfun(0)">立即购买</div>
										</div>
									</div>
									<div class="pc-item-icon" id="pc-item-icon" data-v-f0e540bb>
										<div class="sa-flex-col sa-col-center" data-v-f0e540bb>
											<div class="name" data-v-f0e540bb>专业版</div>
											<div class="desc" data-v-f0e540bb>适用于企业商用</div>
											<div class="price" data-v-f0e540bb>
												<span data-v-f0e540bb>¥</span>
												6800<span data-v-f0e540bb>/套</span>
											</div>
											<div class="btn" data-v-f0e540bb @click="showpayfun(1)">立即购买</div>
										</div>
									</div>
									<div class="pc-item-icon" id="pc-item-icon" data-v-f0e540bb>
										<div class="sa-flex-col sa-col-center" data-v-f0e540bb>
											<div class="name" data-v-f0e540bb>企业版</div>
											<div class="desc" data-v-f0e540bb>
												适用于科技公司/商业使用
											</div>
											<div class="price" data-v-f0e540bb>
												<span data-v-f0e540bb>¥</span>
												13800<span data-v-f0e540bb>/套</span>
											</div>
											<div class="btn" data-v-f0e540bb @click="showpayfun(2)">立即购买</div>
										</div>
									</div>
									<div class="pc-item-icon" id="pc-item-icon" style="background:#fff;" data-v-f0e540bb>
										<div
											class="dingzi sa-flex-col sa-col-center"
											data-v-f0e540bb>
											<div class="name" data-v-f0e540bb>定制+</div>
											<div class="desc" data-v-f0e540bb>私人化定制服务</div>
											<div class="price" data-v-f0e540bb>按需定制</div>
											<div class="btn" data-v-f0e540bb @click="showcode = true">联系商务</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="pc-content" data-v-f0e540bb>
							<div
								class="pc-item undefined pc-item-title"
								style="display: flex"
								data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									产品服务
									<div class="horn" data-v-f0e540bb></div>
								</div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" id="one" data-v-f0e540bb>
									安装文档
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" id="two" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									API接口文档
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									代码全部开源
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									永久支持与更新
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									工单解答
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									指导安装部署服务
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									1对1远程服务
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									售后1对1答疑
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									二次开发指导
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									全套设计资源
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-close1 error" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div
								class="pc-item undefined pc-item-title"
								style="display: flex"
								data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									站点设置
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<!---->
								<!---->
								<!---->
								<!---->
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									基本设置
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									上传配置
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									日志管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									广告管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									单页管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									管理员管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									上传管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									用户组管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div
								class="pc-item undefined pc-item-title"
								style="display: flex"
								data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									陪玩管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<!---->
								<!---->
								<!---->
								<!---->
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									服务类型
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									标签管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									游戏管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									大神管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>

							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									大神申请
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									技能申请
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									技能管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									订单管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									订单评价
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									灵魂匹配
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>

							<div
								class="pc-item undefined pc-item-title"
								style="display: flex"
								data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									商城管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<!---->
								<!---->
								<!---->
								<!---->
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									商品管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									分类管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									订单管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									退款订单
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div
								class="pc-item undefined pc-item-title"
								style="display: flex"
								data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									财务管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<!---->
								<!---->
								<!---->
								<!---->
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									充值管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									充值订单
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									提现管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									礼物记录
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>

							<div
								class="pc-item undefined pc-item-title"
								style="display: flex"
								data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									聊天派对
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<!---->
								<!---->
								<!---->
								<!---->
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									派对类别
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									官方消息
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									表情管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									派对管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									礼物管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									私信记录
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-1" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									音乐管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							
							<div
								class="pc-item undefined pc-item-title"
								style="display: flex"
								data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									活动管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<!---->
								<!---->
								<!---->
								<!---->
							</div>
							
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									活动列表
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									大转盘
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									宝箱管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div
								class="pc-item undefined pc-item-title"
								style="display: flex"
								data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									帖子管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<!---->
								<!---->
								<!---->
								<!---->
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									帖子列表
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									举报管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>

							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									专题管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>

							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									机器人回复
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							
							<div
								class="pc-item undefined pc-item-title"
								style="display: flex"
								data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									会员管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<!---->
								<!---->
								<!---->
								<!---->
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									会员列表
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									头衔管理
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									大V申请
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									申请账号注销
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									批量生成
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div
								class="pc-item undefined pc-item-title"
								style="display: flex"
								data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									第三方对接
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<!---->
								<!---->
								<!---->
								<!---->
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									微信登录
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									微信支付
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									微信H5支付
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									微信原路退款
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									微信提现
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									支付宝支付
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									支付宝原路退款
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									支付宝提现
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									阿里云短信
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									短信
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									物流跟踪(快递鸟)
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									物流跟踪(快递100)
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									七牛云存储
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									阿里云存储
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							<div class="pc-item bg-2" style="display: flex" data-v-f0e540bb>
								<div class="pc-item-name" data-v-f0e540bb>
									地图配置
									<div class="horn" data-v-f0e540bb></div>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div class="pc-item-icon sa-flex sa-row-center" data-v-f0e540bb>
									<i class="iconfont icon-check success" data-v-f0e540bb></i>
								</div>
								<div
									class="pc-item-icon sa-flex sa-row-center"
									data-v-f0e540bb></div>
							</div>
							
							
						</div>
					</div>
				</div>
				<div
					class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3"
					style=""
					data-v-f0e540bb></div>
			</div>

			<!-- 支付弹窗 -->
			<div
				style="z-index: 2003; position: fixed; inset: 0px;"
				class="" v-if="showpay">
				<div
					role="dialog"
					aria-modal="true"
					aria-labelledby="el-id-1024-0"
					aria-describedby="el-id-1024-1"
					class="el-overlay-dialog">
					<div class="el-dialog is-fullscreen buy-dialog" tabindex="-1">
						<header class="el-dialog__header">
							<span role="heading" class="el-dialog__title"></span
							><!--v-if-->
						</header>
						<div id="el-id-1024-1" class="el-dialog__body">
							<div data-v-f0e540bb="" class="dialog-wrap">
								<div data-v-f0e540bb="" class="dialog-header">
									完成支付后，<br
										data-v-f0e540bb="" />请扫码添加官方客服领取授权码！
								</div>
								<div data-v-f0e540bb="" class="check-version sa-flex">
									<div data-v-f0e540bb="" class="check-version-box"
                           v-for="(item,index) in reason" :key="index" @click="buytype = index">
										<div
											data-v-f0e540bb=""
											class="version-box-title " :class="[buytype == index && 'active-title']">
											{{item.title}}
										</div>
										<div
											data-v-f0e540bb=""
											class="version-box-desc " :class="[buytype == index && 'active-desc']">
											{{item.decs}}
										</div>
										<div data-v-f0e540bb="" class="active-left-bg" v-if="buytype == 0&&index == 0"></div>
                              <div data-v-f0e540bb="" class="active-center-bg" v-if="buytype == 1&&index == 1"></div>
                              <div data-v-f0e540bb="" class="active-right-bg" v-if="buytype == 2&&index == 2"></div>
									</div>
								</div>
								<div data-v-f0e540bb="" class="dialog-content">
									<div data-v-f0e540bb="" class="dialog-content-left">
										<div data-v-f0e540bb="" class="left-title">
											选择 火烈鸟陪玩 的5个理由
										</div>
										<div data-v-f0e540bb="">
											<div data-v-f0e540bb="" class="item" v-for="(text,value) in reason[buytype].data" :key="value">
												<div data-v-f0e540bb="" class="item-title">
													{{text.name}}
													<div data-v-f0e540bb="" class="line"></div>
												</div>
												<div data-v-f0e540bb="" class="item-desc">
													{{text.msg}}
												</div>
											</div>
										</div>
									</div>
									<div data-v-f0e540bb="" class="dialog-content-right">
										<form
											data-v-f0e540bb=""
											class="el-form el-form--default el-form--label-top form-box">
											<div
												data-v-f0e540bb=""
												class="el-form-item asterisk-left">
												<label
													id="el-id-1024-4"
													for="el-id-1024-5"
													class="el-form-item__label"
													>手机号</label
												>
												<div class="el-form-item__content">
													<div data-v-f0e540bb="">
														<div data-v-f0e540bb="" class="sa-flex">
															<div data-v-f0e540bb="" class="el-input">
																<!-- input --><!-- prepend slot --><!--v-if-->
																<div class="el-input__wrapper">
																	<!-- prefix slot --><!--v-if-->
                                                   <input
																		class="el-input__inner"
																		type="text"
																		autocomplete="off"
																		placeholder="请输入手机号"
                                                      @input="getvalue"
                                                      :value="tel"
                                                      maxlength="11"
																		id="el-id-1024-5" /><!-- suffix slot --><!--v-if-->
																</div>
																<!-- append slot --><!--v-if-->
															</div>
															<div data-v-f0e540bb="" class="form-btn" @click="submit">
																确定
															</div>
															<!---->
														</div>
														<div data-v-f0e540bb="" class="form-desc">
															为了更好的给您售后服务，请填写手机号
														</div>
													</div>
												</div>
											</div>
											<div data-v-f0e540bb="" class="money-title">¥{{reason[buytype].price}}</div>
											<div data-v-f0e540bb="" class="expired-box">
												<!-- <canvas
													data-v-f0e540bb=""
													width="160"
													height="160"
													style="width: 128px; height: 128px"></canvas> -->
                                    <div class="imgbox">
                                       <img :src="qrcodeimg" alt="">
                                    </div>
                                    
												<div data-v-f0e540bb="" class="expired-shadow" v-if="!qrcodeimg">
													<div data-v-f0e540bb="" class="expired-shadow-title">
														<img
															data-v-f0e540bb=""
															class="warning-img"
															src="@/assets/image/gmsq/warning.png" />
														<div data-v-f0e540bb="">请填写手机号</div>
													</div>
													<!---->
												</div>
											</div>
											<div data-v-f0e540bb="" class="pay-message">
												<div
													data-v-f0e540bb=""
													class="sa-flex sa-col-bottom sa-row-center">
													<div data-v-f0e540bb="" class="sa-flex">
														<img
															data-v-f0e540bb=""
															class="alipay-img"
															src="@/assets/image/gmsq/alipay.png" /><img
															data-v-f0e540bb=""
															class="alipay-img"
															src="@/assets/image/gmsq/wechatpay.png" />
													</div>
													<div data-v-f0e540bb="" class="pay-message-title">
														扫码支付
													</div>
												</div>
												<div
													data-v-f0e540bb=""
													class="pay-message-desc sa-flex">
													<div data-v-f0e540bb="">
														支付完成后请联系官方客服领取授权码
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
								<i data-v-f0e540bb="" class="iconfont icon-close" @click="closepay"></i>
								<div data-v-f0e540bb="" class="shadow"></div>
							</div>
						</div>
						<!--v-if-->
					</div>
				</div>
			</div>

			<!-- 联系商务定制开发 -->
			<div class="el-overlay" v-if="showcode" style="z-index:2001">
				<div
					role="dialog"
					aria-modal="true"
					aria-labelledby="el-id-1024-2"
					aria-describedby="el-id-1024-3"
					class="el-overlay-dialog">
					<div class="el-dialog link-dialog" tabindex="-1">
						<header class="el-dialog__header">
							<span role="heading" class="el-dialog__title"></span>
						</header>
						<div id="el-id-1024-3" class="el-dialog__body">
							<div data-v-f0e540bb="" class="link-title">请扫码咨询商务</div>
							<div data-v-f0e540bb="" class="link-desc">
								请您扫描二维码添加商务<br data-v-f0e540bb="" />
								进行定制开发沟通
							</div>
							<img
								data-v-f0e540bb=""
								class="qrcode-img"
								src="@/assets/image/gmsq/wechat-qrcode.png" />
							<div data-v-f0e540bb="" class="link-btn" @click="showcode = false">我知道了</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
const axios = require('axios');
export default {
   name: "buy",
 watch: {
    buytype(newval, oldval) {
     console.log(newval)
       this.tel = '';
       this.qrcodeimg = ''
   }
 },  
	data() {
      return {
         showcode: false,
         showpay:false,
         buytype: 0,
        qrcodeimg:'', 
         reason: [
            {
               title: '标准版',
               decs:'适用于个人/企业自营',
               price: '1280',
               data: [
                  {
                     name: '独立部署',
                     msg:'源码交付，独立部署' 
                  },{
                     name: '代码开源',
                     msg:'代码完全开源无加密' 
                  },{
                     name: '商业授权',
                     msg:'一次付费，永久授权' 
                  },{
                     name: '安装文档',
                     msg:'完善的部署与使用文档' 
                  }
               ] 
            },{
               title: '专业版',
               price: '6800',
               decs:'适用于企业商用',
               data: [
                  {
                     name: '代码开源',
                     msg:'代码完全开源无加密' 
                  },{
                     name: '商业授权',
                     msg:'一次付费，永久授权' 
                  },{
                     name: '工单解答',
                     msg:'专业技术团队在线回复' 
                  },{
                     name: '安装文档',
                     msg:'完善的部署与使用文档' 
                  },{
                     name: '长期支持与更新',
                     msg:'不断完善的强大功能与基础依赖更新' 
                  }
               ] 
            },{
               title: '企业版',
               price: '13800',
               data: [
                  {
                     name: '代码开源',
                     msg:'代码完全开源无加密' 
                  },{
                     name: '商业授权',
                     msg:'一次付费，永久授权' 
                  },{
                     name: '1对1解答',
                     msg:'专业技术团队直接对接，包含安装、部署、性能调优、二次开发指导与远程协助' 
                  },{
                     name: '设计资源',
                     msg:'原始设计资料与流程指南' 
                  },{
                     name: '长期支持与更新',
                     msg:'不断完善的强大功能与基础依赖更新' 
                  }
               ] 
            },
         ],
         tel:'',
         affixname:''//tableheaderflex
         
      }
	},
   methods: {
      showpayfun(index) {
         this.buytype = index;
         this.showpay = true; 
      },
      closepay() {
         this.showpay = false; 
      },
      getvalue(e) {
         this.tel = e.target.value
         console.log(e.target.value)
      },
      submit() {
         if (this.tel == '') {
            this.$toast("请输入手机号");
            return
         }
         let phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
         if (!phoneReg.test(this.tel)) {
            this.$toast("手机号格式有误!");
            return
         }
         let that = this;
         axios.post('https://peiwan.hlnwl.com/api/index', {
            tel: this.tel,
            type: this.reason[this.buytype].title
         })
         .then(function (response) {
            if (response.status == 200) {
               let res = response.data
               if (res.code == 200) {
                  that.qrcodeimg = res.data.img
               }else{
                  that.$toast(res.msg);
               }
            } else {
               that.$toast("请求失败!");
            }
         })
         .catch(function (error) {
            that.$toast("请求失败!");
         });
      }
   },
   mounted() {
         window.scrollTo({top: 0, behavior:'smooth'});
         let that = this;
         let pcItem = Array.from(document.querySelectorAll('#pc-item-icon'));
         let pcname = document.querySelector('#pc-item-name');
         document.addEventListener("scroll", function scroll(e) {
            if (!document.querySelector('#one')) {
               return false
            }
            if (!document.querySelector('#two')) {
               return false
            }
            let one = document.querySelector('#one').clientWidth;
            let two = document.querySelector('#two').clientWidth;
            var t = document.documentElement.scrollTop || document.body.scrollTop;
            if (t >= 39.9) {
               console.log(two);
               that.affixname = 'tableheaderflex';
               for (let index = 0; index < pcItem.length; index++) {
                  pcItem[index].style.flex = `0 0 ${two}px`
               }
               pcname.style.flex = `0 0 ${one}px`
               document.body.style.overflowX= 'hidden'
            } else {
               that.affixname = 'tableheader'
            }
         }); 
         // el-scrollbar__wrap el-scrollbar__wrap--hidden-default
         let width = document.body.clientWidth;
         if(width<766){
            let scrollbar = document.querySelector('.el-scrollbar__wrap');
            let table__header = document.querySelector('.el-table__header')
            scrollbar.addEventListener("scroll", function (e) {
            var t = e.target.scrollLeft;
            table__header.style.transform= `translateX(-${e.target.scrollLeft}px)`
            }); 
         };
         window.addEventListener('resize', (e) => {
            let width = document.body.clientWidth;
            if(width<766){
               if (!document.querySelector('.el-scrollbar__wrap')) {
                  return false
               }
               let scrollbar = document.querySelector('.el-scrollbar__wrap');
               let table__header = document.querySelector('.el-table__header')
               scrollbar.addEventListener("scroll", function (e) {
               var t = e.target.scrollLeft;
               table__header.style.transform= `translateX(-${e.target.scrollLeft}px)`
               }); 
            };
            if (!document.querySelector('#one')) {
               return false
            }
            if (!document.querySelector('#two')) {
               return false
            }
            let two = document.querySelector('#two').clientWidth;
            let one = document.querySelector('#one').clientWidth;
            for (let index = 0; index < pcItem.length; index++) {
               pcItem[index].style.flex = `0 0 ${two}px`
            };
            pcname.style.flex = `0 0 ${one}px`
         })
         
      },
   beforeDestroy() {
      document.removeEventListener("scroll", () => {})
	   document.removeEventListener("resize", () => {})
   },
};
</script>
<style scoped lang="sass">
   @import '../assets/css/index.css'
   @import '../assets/css/buy.css'
   // transform: 
</style>
